import React, { useEffect, useState } from 'react';
import { Badge, Spinner } from 'reactstrap';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import TablePageHeading from '../components/page_heading/TablePageHeading';
import TableList from '../components/table/TableList';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_tenants_list, loading_retrieve_tenants_list, reset_retrieve_tenants_list, success_retrieve_tenants_list } from '../../reducers/auth_tenant/retrieve_tenants_list_Slice';
import { RETRIEVE_TENANTS_LIST_ERROR_MSG, RETRIEVE_TENANTS_LIST_SUCCESS_MSG } from '../../utils/error_success_messages';
import * as app_consts from "../../utils/app_consts";
import { RETRIEVE_TENANTS_LIST_API } from '../../api/api_data';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../utils/Utils';
import { BiErrorCircle } from 'react-icons/bi';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import AuthTenantPageError from '../error/AuthTenantPageError';
import AddTenantModal from '../components/modal/AddTenantModal';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../components/Component';
import { Link } from 'react-router-dom';
import moment from 'moment';
import AuthTenantNoData from '../error/AuthTenantNoData';

const AdminTenantsList = ({ tenant_info, user_info }) => {

  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [add_tenant_modal, setAddTenantModal] = useState(false);
  const [sm, updateSm] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = page_data?.slice(indexOfFirstItem, indexOfLastItem);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  // 
  useEffect(() => {
    retrieve_tenants();
  }, []);

  // Retrieve Tenants List
  const retrieve_tenants = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenants_list, success_retrieve_tenants_list, fail_retrieve_tenants_list, RETRIEVE_TENANTS_LIST_ERROR_MSG, RETRIEVE_TENANTS_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANTS_LIST_API}`));
  };
  // Listen
  const retrieve_tenants_list_listener = useSelector((state) => state.retrieve_tenants_list.retrieve_tenants_list);

  useEffect(() => {
    if (retrieve_tenants_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenants_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_tenants_list_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenants_list_listener.message, app_consts.FAIL);
          messageToast(retrieve_tenants_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenants_list_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenants_list_listener.data);
        }
        dispatch(reset_retrieve_tenants_list());
      }
    }
  }, [retrieve_tenants_list_listener]);

  const openAddListModal = () => {
    setAddTenantModal(true);
  };


  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Order` : "Orders"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Orders</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Total Tenants ${page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_tenants();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    {
                      loading || error ? "" : (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_TENANT)) && (
                        <>
                          <li className="nk-block-tools-opt">
                            <Button onClick={openAddListModal} color="primary" className="btn-icon">
                              <Icon name="plus"></Icon>
                            </Button>
                          </li>
                        </>
                      )
                    }
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Email Address</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Date Created</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">URL Prefix</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/tenants/${item?.id}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.name ? addThreeDots(item?.name, 30) : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.mobile_number || "--"} </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.email_address || 0}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.url_prefix || 0}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/tenants/${item?.id}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>

                            {/* Pagination */}

                            <div className="card-inner">
                              {currentItems.length > 0 ? (
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              ) : (
                                <div className="text-center">
                                  <span className="text-silent">No data found</span>
                                </div>
                              )}
                            </div>
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Tenants Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
      <AddTenantModal openModal={add_tenant_modal} setOpenModal={setAddTenantModal} modalTitle="Add Tenant" succFunc={retrieve_tenants} tenant_info={tenant_info} />
    </>
  );
};

export default AdminTenantsList;